/**
 * Build query params for GET /api/public/product/random (server fallback only).
 */
function stripGid(value) {
  if (value == null) return "";
  const raw = String(value);
  return raw.includes("/") ? raw.split("/").pop() : raw;
}

function toCollectionGid(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (raw.startsWith("gid://")) return raw;
  const id = raw.includes("/") ? raw.split("/").pop() : raw;
  return `gid://shopify/Collection/${id}`;
}

function normalizeTags(tags) {
  if (Array.isArray(tags)) {
    return tags.map((tag) => String(tag).trim()).filter(Boolean);
  }
  if (typeof tags === "string") {
    return tags
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean);
  }
  return [];
}

export function buildRandomApiQueryParams(
  productsToOffer,
  { shop, productCount = 1, contextProduct = null } = {}
) {
  if (!productsToOffer?.type) return {};

  const params = {
    shop,
    productCount: Math.max(1, Number(productCount) || 1),
    type: productsToOffer.type,
  };

  const value = productsToOffer.value;
  const conditionType = productsToOffer.conditionType || "contains";

  switch (productsToOffer.type) {
    case "specific_product":
    case "show_current_product":
      params.productIds = (value || [])
        .map((item) => stripGid(item?.id))
        .filter(Boolean)
        .join(",");
      break;
    case "shopify_recommended":
    case "ai_recommended":
      if (contextProduct?.id) {
        const contextId = stripGid(contextProduct.id);
        params.productIds = contextId;
        params.excludeProductIds = contextId;
      }
      break;
    case "product_from_collection":
    case "realtime_same_collection":
      params.collectionIds = (value || [])
        .map((item) => toCollectionGid(item?.id != null ? item.id : item))
        .filter(Boolean)
        .join(",");
      if (
        productsToOffer.type === "realtime_same_collection" &&
        !params.collectionIds &&
        contextProduct?.collection_id
      ) {
        params.collectionIds = toCollectionGid(contextProduct.collection_id);
      }
      break;
    case "product_specific_title":
    case "realtime_title_contains":
      params.title = (value || [])
        .map((item) =>
          typeof item === "string" ? item : item?.title || item?.id || String(item)
        )
        .filter(Boolean)
        .join(",");
      params.titleMatchType =
        productsToOffer.type === "realtime_title_contains"
          ? conditionType || "contains"
          : conditionType;
      break;
    case "realtime_title_starts_with":
      params.title = String(value?.[0] || contextProduct?.title || "");
      params.titleMatchType = "startsWith";
      break;
    case "realtime_title_ends_with":
      params.title = String(value?.[0] || contextProduct?.title || "");
      params.titleMatchType = "endsWith";
      break;
    case "product_specific_tag":
    case "realtime_same_tags":
      params.tag = (
        value?.length
          ? value.map((item) =>
              typeof item === "string" ? item : item?.tag || item?.title || item
            )
          : normalizeTags(contextProduct?.tags)
      )
        .filter(Boolean)
        .join(",");
      params.tagMatchType = conditionType;
      break;
    case "product_specific_vendor":
    case "realtime_same_vendor":
      params.vendor = String(
        value?.[0]?.vendor ||
          value?.[0] ||
          contextProduct?.vendor ||
          ""
      );
      params.vendorMatchType = conditionType;
      break;
    default:
      break;
  }

  return params;
}
